<template lang="html">
  <div v-show="el.newFile" id="boxa" :style="{top: boxPosition.top,left: boxPosition.left}" class="main" :class="el.maxFile">
    <div class="name" id="barb">
      <i class="material-icons">
        send
      </i>
      <span class="word">{{message.Al118}}</span>
      <span class="cntrol">
        <i class="material-icons" @click="onClosea">
          close
        </i>
        <!-- <span class="icon" v-show="el.maxFile === ''" @click="onMin">
          &#xe808;
        </span>
        <span class="icon" v-show="el.maxFile === 'min'" @click="onMax">
          &#xe809;
        </span> -->
      </span>
    </div>
    <div class="box"
      v-loading="boxLoading"
      :element-loading-text="boxLoadingText"
    >
      <div class="cell">
        <span class="cell-name">
          {{message.Al119}}
        </span>
        <el-select
          v-model="usersValue"
          multiple
          filterable
          :disabled="isDisabled"
          style="width:360px;margin:0 auto"
          :placeholder="message.Al120"
          @click = "userList()"
          @change = "selectAll"
        >
         <!-- <el-input
         v-if="account.role !==2"
         size="small"
         :placeholder="message.Al159"
         v-model="email"
         @keyup.enter.native="addEmail()"
         style="width:328px;margin: 0 15px 8px 15px"
         >
         </el-input> -->
          <el-option
            v-for="item in users"
            :key="item.value"
            :label="item.label"
            :value="item.value">
            <span class="user-name">{{ item.label }}</span>
            <span class="user-email" :title="item.email">{{ item.email }}</span>
          </el-option>
        </el-select>
      </div>
      <div class="cell" v-if="saveMode===2 && can_archive">
        <span class="cell-name">
          {{message.Al230}}
        </span>
        <el-checkbox
          v-model="isArchive"
          style="width:360px;margin:4px auto 5px;color:#aaa;font-weight:400;">
          {{message.Al230}}
        </el-checkbox>
      </div>
      <div class="cell">
        <span class="cell-name">
          {{message.Al121}}
        </span>
        <el-input
          v-model.trim="title"
          style="width:360px;margin:0 auto"
          maxlength="32"
          :placeholder="message.Al121">
        </el-input>
      </div>
      <div class="cell file">
        <span class="cell-name">
          {{message.Al118}}
        </span>
        <span class="upload-choose">
          {{message.Al137}}
          <div class="upload-body">
            <span class="upload-cell" @click="addFiles">{{message.Al157}}</span>
            <span class="upload-cell" @click="addFolder">{{message.Al158}}</span>
          </div>
        </span>
        <div
          id="dodrop"
          class="upload"
          @drop="dodrop($event)"
          @ondragenter="over($event)"
          v-loading="loading"
          :element-loading-text="message.Al122"
         >
          <i class="el-icon-upload"
            v-show="uploadIcon"
            style="font-size:120px;color:#ccc;margin-top:10px"
          ></i>
          <div style="color:#ccc" v-show="uploadIcon" class="el-upload__text">{{message.Al123}}</div>
          <div class="fileList">
            <ul class="el-upload-list el-upload-list--text">
              <li class="el-upload-list__item is-success" v-for="(file, index) in files" :key="file.id">
                <a class="el-upload-list__item-name">
                  <i class="el-icon-document" v-show="file.file"></i>
                  <i class="material-icons icon-folder" v-show="!file.file">folder_open</i>
                  {{ file.name }}
                </a>
                <label class="el-upload-list__item-status-label">
                  <i class="el-icon-upload-success el-icon-circle-check"></i>
                </label>
                <i class="el-icon-close" @click="clearFile(index)"></i>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="cell" style="border-bottm:1px solid #ccc">
        <span class="cell-name">
          {{message.Al124}}
        </span>
        <el-input
        type="textarea"
        v-model="notes"
        :placeholder="message.Al125"
        maxlength="255"
        style="width:360px;margin: 0 auto;"
        >
        </el-input>
      </div>
      <el-button type="primary" :disabled="sendDisabled" @click="sentFiles()" class="submit" size="small">{{message.Al126}}</el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import startDrag from '@/global/drag.js'
export default {
  computed: {
    ...mapGetters({
      el: 'el',
      size: 'size',
      account: 'account',
      app: 'app',
      space: 'space'
    }),
    sendDisabled: function () {
      if (
        this.usersValue.length === 0 ||
        this.files.length === 0 ||
        this.title === ''
      ) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    'el.newFile': function (val) {
      if (val) {
        this.resizeWinMax()
        this.userList()
      }
    },
    files: function (val) {
      if (val.length !== 0) {
        this.uploadIcon = false
      } else {
        this.uploadIcon = true
      }
    },
    size: function (val) {
      if (this.el.maxFile === '') {
        this.resizeWinMax()
      } else {
        this.onClosea()
      }
    },
    'space.id': function (val) {
      this.getWorkspaceSaveMode()
    },
    isArchive: function (val) {
      if (val) {
        this.isDisabled = true
        this.usersValue = ['archive']
      } else {
        this.isDisabled = false
        this.usersValue = []
      }
    }
  },
  data () {
    return {
      message: {
        Al118: this.$lang.ui.app.l118,
        Al119: this.$lang.ui.app.l119,
        Al120: this.$lang.ui.app.l120,
        Al121: this.$lang.ui.app.l121,
        Al122: this.$lang.ui.app.l122,
        Al123: this.$lang.ui.app.l123,
        Al124: this.$lang.ui.app.l124,
        Al125: this.$lang.ui.app.l125,
        Al126: this.$lang.ui.app.l126,
        Al132: this.$lang.ui.app.l132,
        Al137: this.$lang.ui.app.l137,
        Al157: this.$lang.ui.app.l157,
        Al158: this.$lang.ui.app.l158,
        Al159: this.$lang.ui.app.l159,
        Al230: this.$lang.ui.app.l230
      },
      browser: this._global.config.browser,
      showChoose: false,
      showChooseCell: false,
      boxPosition: {
        left: 0,
        top: 0
      },
      boxLoading: false,
      boxLoadingText: this.$lang.ui.app.l127,
      uploadIcon: true,
      loading: false,
      users: [],
      email: '',
      files: [],
      usersValue: [],
      oldUserValue: [],
      title: '',
      notes: '',
      isDisabled: false,
      saveMode: '',
      isArchive: false,
      can_archive: true
    }
  },
  mounted () {
    this._global.windowSize()
    window.removeEventListener('resize', this._global.windowSize, false)
    window.addEventListener('resize', this._global.windowSize, false)
    window.CydexDrage = (type, path) => {
      if (this.el.newFile) {
        if (type === 'file') {
          const fileNameList = path.split('/')
          const fileName = fileNameList[fileNameList.length - 1]
          if (this.title === '') {
            this.title = fileName
          }
          this.files.push({
            name: fileName,
            path: path,
            file: true
          })
        }
        if (type === 'folder') {
          const folderNameList = path.split('/')
          const folderName = folderNameList[folderNameList.length - 1]
          if (this.title === '') {
            this.title = folderName
          }
          this.files.push({
            name: folderName,
            path: path,
            file: false
          })
        }
      }
    }
    this.getWorkspaceSaveMode()
  },
  methods: {
    resizeWinMax () {
      this.onMax()
      this.boxPosition.left = this.size.width * 0.5 - 230 + 'px'
      this.boxPosition.top = this.size.height * 0.15 + 'px'
      // var oBox = document.getElementById('box')
      // var oBar = document.getElementById('bar')
      // startDrag(this.boxPosition, oBar, oBox)
    },
    getWorkspaceSaveMode () {
      var projectId = localStorage.getItem('projectId')
      this.$api.getProject(projectId, response => {
        this.saveMode = response.project.save_mode
        if (this.saveMode !== 2) {
          this.isDisabled = false
        }
      })
    },
    userList () {
      this.isArchive = false
      this.email = ''
      var id = localStorage.getItem('projectId')
      this.$http.get('/cydex/api/v1/projects/' + id + '/members', { params: {
        'sort': 'name'
      } })
        .then(response => {
          this.users = []
          this.can_archive = response.data.can_archive
          for (var i = 0; i < response.data.members.length; i++) {
            if (response.data.members[i].user_info.is_black_user === 0) {
              this.users.push({
                label: response.data.members[i].user_info.name,
                value: response.data.members[i].user_info.id,
                email: response.data.members[i].user_info.email
              })
            }
          }
          this.users.unshift({
            label: this.$lang.ui.app.l229,
            value: 'All_select'
          })
        })
    },
    selectAll (val) {
      let allUsers = this.users.map(item => {
        return item.value
      })
      let oldUser = this.oldUserValue.length > 0 ? this.oldUserValue : []
      if (val.includes('All_select')) {
        this.usersValue = allUsers
      }
      if (oldUser.includes('All_select') && !val.includes('All_select')) {
        this.usersValue = []
      }
      if (oldUser.includes('All_select') && val.includes('All_select')) {
        const index = val.indexOf('All_select')
        val.splice(index, 1)
        this.usersValue = val
      }
      if (!oldUser.includes('All_select') && !val.includes('All_select')) {
        if (val.length === allUsers.length - 1) {
          this.usersValue = ['All_select'].concat(val)
        }
      }
      this.oldUserValue = this.usersValue
    },
    onClosea () {
      this.$store.dispatch('newFile', false)
      this.users = []
      this.files = []
      this.usersValue = []
      this.oldUserValue = []
      this.title = ''
      this.notes = ''
      this.boxLoading = false
      this.boxLoadingText = ''
      this.uploadIcon = true
      this.loading = false
    },
    onMin () {
      this.boxPosition.left = this.size.width - 380 + 'px'
      this.boxPosition.top = this.size.height - 85 + 'px'
      this.controlShow = false
      var oBox = document.getElementById('box')
      var oBar = document.getElementById('bar')
      startDrag(this.boxPosition, oBar, oBox)
      this.$store.dispatch('maxFile', 'min')
    },
    onMax () {
      this.boxPosition.left = this.size.width * 0.5 - 230 + 'px'
      this.boxPosition.top = this.size.height * 0.15 + 'px'
      this.controlShow = true
      this.el.maxFile = ''
    },
    over (e) {
    },
    dodrop (e) {
      if (this._global.config.browser === 'qt') {
        return
      }
      this._global.fileFalse(e.dataTransfer.files, nameList => {
        if (nameList.length === 0) {
          return
        }
        this.loading = true
        var value = nameList
        if (this.title === '') {
          this.title = value[0].fileName
        }
        this.$app.drag(value, response => {
          this.loading = false
          if (response.draggedFiles) {
            for (var i = 0; i < response.draggedFiles.length; i++) {
              var fileNameList = response.draggedFiles[i].split('/')
              var fileName = fileNameList[fileNameList.length - 1]
              this.files.push({
                name: fileName,
                path: response.draggedFiles[i],
                file: true
              })
            }
            for (var a = 0; a < response.draggedFolders.length; a++) {
              var folderNameList = response.draggedFolders[a].split('/')
              var folderName = folderNameList[folderNameList.length - 1]
              this.files.push({
                name: folderName,
                path: response.draggedFolders[a],
                file: false
              })
            }
          }
        })
      })
    },
    addEmail () {
      this.email = this.email.toLowerCase()
      var checkEmail = /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/
      if (!checkEmail.test(this.email)) {
        this.$message({
          message: this.$lang.ui.prompt.l135,
          type: 'warning',
          duration: 1200
        })
        return
      }
      for (var i = 0; i < this.usersValue.length; i++) {
        if (this.usersValue[i] === this.email) {
          this.email = ''
          return
        }
      }
      for (var x = 0; x < this.users.length; x++) {
        if (this.email === this.users[x].email.toLowerCase()) {
          var email = this.users[x].value
          for (var y = 0; y < this.usersValue.length; y++) {
            if (this.usersValue[y] === email) {
              this.email = ''
              return
            }
          }
          this.usersValue.push(email)
          this.email = ''
          return
        }
      }
      this.usersValue.push(this.email)
      this.email = ''
    },
    addFiles () {
      this.$app.appFiles(response => {
        this.loading = false
        if (response.selectedFiles) {
          for (var i = 0; i < response.selectedFiles.length; i++) {
            var fileNameList = response.selectedFiles[i].split('/')
            var fileName = fileNameList[fileNameList.length - 1]
            this.files.push({
              name: fileName,
              path: response.selectedFiles[i],
              file: true
            })
          }
          // for (var a = 0; a < response.draggedFolders.length; a++) {
          //   var folderNameList = response.draggedFolders[a].split('/')
          //   var folderName = folderNameList[folderNameList.length - 1]
          //   this.files.push({
          //     name: folderName,
          //     path: response.draggedFolders[a],
          //     file: false
          //   })
          // }
        }
        if (this.title === '') {
          this.title = this.files[0].name
        }
      })
    },
    addFolder () {
      this.$app.appFolder(response => {
        this.loading = false
        if (response.selectedFolder) {
          // for (var i = 0; i < response.draggedFiles.length; i++) {
          //   var fileNameList = response.draggedFiles[i].split('/')
          //   var fileName = fileNameList[fileNameList.length - 1]
          //   this.files.push({
          //     name: fileName,
          //     path: response.draggedFiles[i],
          //     file: true
          //   })
          // }
          // for (var a = 0; a < response.selectedFolder.length; a++) {
          //   var folderNameList = response.selectedFolder[a].split('/')
          //   var folderName = folderNameList[folderNameList.length - 1]
          //   this.files.push({
          //     name: folderName,
          //     path: response.selectedFolder[a],
          //     file: false
          //   })
          // }
          var folderNameList = response.selectedFolder.split('/')
          var folderName = folderNameList[folderNameList.length - 1]
          this.files.push({
            name: folderName,
            path: response.selectedFolder,
            file: false
          })
        }
        if (this.title === '') {
          this.title = this.files[0].name
        }
      })
    },
    clearFile (index) {
      this.files.splice(index, 1)
    },
    sentFiles () {
      if (
        this.files.length === 0 ||
        this.usersValue.length === 0
      ) {
        return
      }
      this.boxLoadingText = this.$lang.ui.app.l127
      this.boxLoading = true
      setTimeout(() => {
        if (this.boxLoading) {
          var ae = []
          for (var b = 0; b < this.files.length; b++) {
            if (!this.files[b].file) {
              ae.push(this.files[b].path)
            }
          }
          this.$app.getFilesNum(ae, response => {
            if (response.number > 2000) {
              this.boxLoadingText = this.$lang.ui.app.l128
            }
          })
        }
      }, 15000)
      var emailList = []
      var userList = []
      var checkEmail = /@/
      for (var i = 0; i < this.usersValue.length; i++) {
        if (checkEmail.test(this.usersValue[i])) {
          emailList.push(
            this.usersValue[i]
          )
        } else {
          userList.push(
            this.usersValue[i]
          )
        }
      }
      if (userList.includes('All_select')) {
        userList.shift()
      }
      var filesList = []
      var foldersList = []
      for (var a = 0; a < this.files.length; a++) {
        if (this.files[a].file) {
          filesList.push(this.files[a].path)
        } else {
          foldersList.push(this.files[a].path)
        }
      }

      var all = {
        'projectId': localStorage.getItem('projectId'),
        'title': this.title,
        'notes': this.notes,
        'receiverIds': userList,
        'fileNames': filesList,
        'folderNames': foldersList,
        'new-task': 2
      }
      if (emailList.length !== 0) {
        var e = {
          email_list: emailList,
          project_id: localStorage.getItem('projectId')
        }
        this.$api.getEmailUid(e, response => {
          all.receiverIds = userList.concat(response.receivers)
          if (response !== 1) {
            this.sentFilesFuc(all)
          } else {
            this.boxLoading = false
            this.$message({
              message: this.$lang.ui.prompt.l135,
              type: 'warning',
              duration: 1200
            })
          }
          // all.receiverIds =
        })
      } else {
        this.sentFilesFuc(all)
      }
    },
    sentFilesFuc (all) {
      this.$app.newPackage(all, response => {
        this.boxLoading = false
        if (response === 1) {
          this.$message.error(this.$lang.ui.app.l129 + ' (error: ' + response.error + ')')
          return
        }
        if (response.error === 11 || response.error === 111) {
          this.$message.error(this.$lang.ui.app.l130)
          return
        }
        var id = response.pkgId
        var errNum = response.error
        if (id === '') {
          if (errNum === 1293 || errNum === 1291 || errNum === 1301 || errNum === 1300) {
            return
          } else {
            this.$message.error(this.$lang.ui.app.l129 + ' (error: ' + response.error + ')')
            return
          }
        }
        this.$store.dispatch('sentFile', true)
        this.onClosea()
        if (response.error === 0 || response.error === 100) {
          this.$message({
            message: this.$lang.ui.app.l131,
            type: 'success',
            duration: 4000
          })
          setTimeout(() => {
            this.$store.dispatch('transferEl', 'upload')
          }, 200)
        } else {
          this.$message.error(this.$lang.ui.app.l129)
        }
      })
    }
    // getQuestToSend () {
    //   var token = sessionStorage.getItem('requestToken')
    //   if (token) {
    //     this.$api.getRequestToSendInfo(token, response => {
    //       if (response.err === 0) {
    //         this.$api.getProject(response.data.project_id, info => {
    //           var data = {
    //             id: info.project.id,
    //             name: info.project.name,
    //             imgUrl: info.project.pic_url
    //           }
    //           this.$store.dispatch('addSpace', data)
    //           localStorage.setItem('projectId', data.id)
    //           localStorage.setItem('projectName', data.name)
    //           localStorage.setItem('projectUrl', data.imgUrl)
    //           sessionStorage.removeItem('requestToken')
    //           this.$store.dispatch('newFile', true)
    //           var uid = response.data.receive_user_info.id
    //           this.userList(() => {
    //             this.usersValue.push(uid)
    //           })
    //         })
    //       }
    //     })
    //   }
    // }
  }
}
</script>

<style lang="css" scoped>
.main {
  z-index: 10000;
  position: fixed;
  width: 460px;
  /*left: 50%;
  top: 15%;
  margin-left: -230px;*/
  background-color: #fff;
  overflow: hidden;
  height: auto;
  border-radius: 4px;
  box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.35);
}
.name {
  font-size: 14px;
  padding: 0 15px;
  text-align: left;
  /* cursor: move; */
  color: #fff;
  height: 35px;
  line-height: 35px;
  /*background-color: #d9534f;*/
  background-color: #f37e21;
}
.upload-body {
  display: none;
  position: absolute;
  border: 1px solid #d8dce5;
  left: -2px;
  top: 16px;
  background-color: #fff;
  border-radius: 4px;
  width: 115px;
}
.upload-cell {
  display: inline-block;
  color: #5a5e66;
  padding: 4px 8px;
  width: 100%;
}
.upload-cell:hover {
  color: #212121;
}
.upload-choose:hover .upload-body {
  display: block;
}
.upload-choose {
  position: absolute;
  display: block;
  cursor: pointer;
  top: 8px;
  color: #007bc5;
  z-index: 3;
  left: 50px;
}
.cntrol i {
  float: right !important;
  cursor: pointer;
  text-align: center;
}
.name .word {
  display: inline-block;
  padding-left: 8px;
}
.main.min {
  left: auto;
  top: auto;
  right: 10px;
  width: 285px;
  bottom: 30px;
  height: 35px;
}
.main.min .box {
  display: none;
}
.name i {
  margin-top: 5px;
  float: left;
}
.box {
  overflow: hidden;
  width: 100%;
  padding: 15px;
}
.user-name {
  float: left;
  width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.user-email {
  float: right;
  color: #8492a6;
  width: 140px;
  text-align: right;
  font-size: 12px;
  padding-right: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cell {
  display: flex;
  width: 100%;
  padding: 4px 1px;
  /*border-bottom: 1px solid #ccc;*/
}
.cell.file {
  position: relative;
}
.cell-name {
  display: none;
  float: left;
  font-size: 14px;
  width: 60px;
  font-weight: 600;
  padding-left: 8px;
  text-align: left;
  line-height: 35px;
}
.file  .cell-name {
  padding-top: 6px;
  line-height: 22px;
}
.cell-input {
  height: 35px;
  width: 360px;
  margin: 0 auto;
  border: 0;
  font-size: 16px;
}
textarea {
  flex-grow: 1;
  margin: 0 auto;
  height: 100px;
  width: 362px;
  max-width: 362px;
  border-radius: 4px;
  border: 1px solid #ccc;
}
.submit {
  float: right;
  margin-top: 10px;
  margin-bottom: 15px;
}
.upload {
  position: relative;
  margin: 0 auto;
  width: 360px;
  height: 180px;
  text-align: center;
  border: 1px dashed #ccc;
  border-radius: 12px;
}
.fileList {
  position: absolute;
  top: 14px;
  left: 12px;
  right: 12px;
  bottom: 4px;
  overflow-y: auto;
}
.el-upload-list__item-name {
  text-align: left;
}
.icon-folder {
  font-size: 15px;
  font-weight: 600;
  height: 100%;
  color: #97a8be;
  padding-left: 1px;
  margin-right: 6px;
}
.el-upload-list__item-name:hover .icon-folder {
  color: #97a8be;
}
.el-message__group {
  color: #212121 !important;
}
</style>
